export default __webpack_public_path__ + "static/media/slide3.8f0e1b55.jpg";